import { retryPaymentMembership } from "../../../../Redux/Members/MembersActions";
import { AppDispatch, RootState } from "../../../../Redux/store";
import { ColDef, GridReadyEvent } from "ag-grid-community";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../../Common/Loading/Loading";
import styles from "./PaymentHistory.module.scss";
import { AgGridReact } from "ag-grid-react";
import { useEffect, useState } from "react";
import moment from "moment";

interface PaymentHistoryType {
  paymentDate: string;
  invoiceDescription: string;
  amount: number;
  cardNum: string;
}

const defaultColDef: ColDef = {
  resizable: true,
  sortable: true,
  filter: false,
  wrapText: true,
  autoHeight: true,
  unSortIcon: true,
};

function PaymentHistory() {
  const dispatch = useDispatch<AppDispatch>();
  const { profileByIdData } = useSelector((state: RootState) => state.profile);
  const { retryPaymentMembershipLoading } = useSelector(
    (state: RootState) => state.members,
  );
  const [rowData, setRowData] = useState<PaymentHistoryType[]>([]);
  const [gridApi, setGridApi] = useState<any>(null);

  const onGridReady = (params: GridReadyEvent) => {
    setGridApi(params.api);
    params.api.sizeColumnsToFit();
  };
  const columnDefs: ColDef<PaymentHistoryType>[] = [
    {
      headerName: "Date",
      field: "paymentDate",
      minWidth: 100,
      valueGetter: (params) => {
        return moment(params?.data?.paymentDate).format("MM/DD/YYYY");
      },
    },
    {
      headerName: "Description",
      field: "invoiceDescription",
      minWidth: 250,
    },
    {
      headerName: "Amount",
      field: "amount",
      minWidth: 100,
      valueFormatter: (params) => `$${params.value.toFixed(2)}`,
    },
    {
      headerName: "Payment Method",
      field: "cardNum",
      minWidth: 150,
      valueGetter: (params) => {
        return `Card-${params?.data?.cardNum}`;
      },
    },
  ];

  useEffect(() => {
    if (!gridApi) return;

    const handleResize = () => {
      gridApi.sizeColumnsToFit();
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [gridApi]);

  useEffect(() => {
    if (profileByIdData) {
      setRowData(profileByIdData?.payments);
    }
  }, [profileByIdData]);

  const retryPaymentHandler = () => {
    if (!retryPaymentMembershipLoading) {
      dispatch(
        retryPaymentMembership({
          memberId: profileByIdData?.member?.memberId,
        }),
      );
    }
  };

  return (
    <div className={styles.mainContainer}>
      {retryPaymentMembershipLoading && <Loading />}
      {profileByIdData?.member?.issubscriptionfailed === true && (
        <div className={styles.buttonContainer}>
          <button className={styles.button} onClick={retryPaymentHandler}>
            Retry payment
          </button>
        </div>
      )}

      <div className={styles.gridContainer}>
        <AgGridReact
          className={styles.grid}
          rowData={rowData}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          onGridReady={onGridReady}
          pagination={true}
          paginationPageSize={10}
          paginationPageSizeSelector={[5, 10, 20, 50, 100]}
          animateRows={true}
          domLayout="autoHeight"
        />
      </div>
    </div>
  );
}

export default PaymentHistory;
